import { Dispatch, SetStateAction } from 'react';

export enum rtaNames {
    CAMS = 'CAMS',
    KFIN = 'KFIN',
}

export type FatcaCheckProps = {
    rtaName: rtaNames;
    checkFatca: any;
    callApi?: boolean;
    showDialog?: boolean;
    cancelCallBack?: null | ((setError: Dispatch<SetStateAction<boolean>>) => void);
};

export type rtaType = {
    rtaName: string;
    fhFatcaStatus: string;
};

export type FatcaCheckResponseType = {
    body: {
        reqId: string;
        pan: string;
        mobile: string;
        email: string;
        pekrn: string;
        data: Array<rtaType>;
    };
};
